import { useMutation } from "@tanstack/react-query"

export async function checkToken(token?: string | null) {
  if (!token || token.length === 0) {
    return false
  }

  try {
    const response = await fetch(`/api/auth/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
    return response.ok
  } catch {
    return false
  }
}

export const useCheckTokenMutation = () =>
  useMutation({
    mutationFn: async (token: string | null) => await checkToken(token),
    retry: false,
  })
